/**
 * @generated SignedSource<<db88116863b83ebf51e5be5dd63f4799>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OtherExpensesEditor_project$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"OtherExpenseEditRow_project">;
  readonly " $fragmentType": "OtherExpensesEditor_project";
};
export type OtherExpensesEditor_project$key = {
  readonly " $data"?: OtherExpensesEditor_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"OtherExpensesEditor_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OtherExpensesEditor_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OtherExpenseEditRow_project"
    }
  ],
  "type": "projects",
  "abstractKey": null
};

(node as any).hash = "c3d029fb04cec5437f2dde0a7d25164a";

export default node;
